(function() {
    var $form = null
    var $loader = null

    $.nette.ext('formloading', {
        before: function(xhr,settings) {
            $form = settings.nette ? settings.nette.form : null
            if (!$form) {
                return
            }
            if ($form.length <= 0) {
                return
            }
            $form.addClass('is-loading')

            var loaderId = $form.attr('data-loader')

            //vyjimky kuvli BE
            if ($form[0].id === 'form-grid') {
                loaderId = 'main-loader'
            }
            if (!loaderId) {
                return
            }

            var loader = document.getElementById(loaderId)
            if (!loader) {
                return
            }

            if ($loader) {
                return
            }
            $loader = $(loader)
            var loading = document.createElement('div')
            loading.className = 'loader'
            loader.appendChild(loading)
        },
        success: function(xhr) {
            if ($form && $form.length > 0) {
                $form.removeClass('is-loading')
                $form = null
            }

            if ($loader) {
                $loader.empty()
                $loader = null
            }
        }
    })

    $.nette.ext('ajax-loading', {
        start(xhr, settings) {
            if (settings?.nette?.el) {
                settings.nette.el[0].classList.add('is-loading')
            }
        },
        complete(xhr, status, settings) {
            if (settings?.nette?.el) {
                settings.nette.el[0].classList.remove('is-loading')
            }
        }
    })
})();